"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));
var analyticsEvents = _interopRequireWildcard(require("../analytics"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Use global performance object if it exists, else use the native Date object
var timer = typeof performance !== 'undefined' && typeof performance.now === 'function' ? performance : Date;
function createAnalyticsMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$mapStateToAn = options.mapStateToAnalytics,
    mapStateToAnalytics = _options$mapStateToAn === void 0 ? function () {
      return {};
    } : _options$mapStateToAn;
  var logEntry = {};
  return function (_ref) {
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        // check if we have a window _analytics object, if we don't  - do not do anything
        if (typeof window === 'undefined' || typeof action === 'function' || action.type === 'FETCH') {
          return next(action);
        }
        if (!window._analytics) {
          return next(action);
        }
        var _action$meta = action.meta,
          _action$meta2 = _action$meta === void 0 ? {} : _action$meta,
          _action$meta2$analyti = _action$meta2.analytics,
          analyticsMeta = _action$meta2$analyti === void 0 ? {} : _action$meta2$analyti;
        if (analyticsMeta === false || analyticsMeta && analyticsMeta.track === false) {
          return next(action);
        }
        if (!(0, _isPlainObject.default)(analyticsMeta)) {
          console.warn('action.meta.analytics is required to be a plain object.');
          analyticsMeta = {};
        }
        var started = timer.now();
        var returnedValue = next(action);
        logEntry.startedTime = new Date();
        logEntry.duration = timer.now() - started;
        var nextState = getState();
        var fromState = mapStateToAnalytics(nextState, action, analyticsEvents);
        if (fromState !== false) {
          fromState = fromState === null ? {} : fromState;
          if (!(0, _isPlainObject.default)(fromState)) {
            console.warn('mapStateToAnalytics is required to return false, null, or a plain object.');
            fromState = {};
          }
          analyticsMeta = _objectSpread(_objectSpread(_objectSpread({}, fromState), analyticsMeta), {}, {
            appData: _objectSpread(_objectSpread({}, fromState.appData), analyticsMeta.appData)
          });
          var analyticsMetaProvided = analyticsMeta.hasOwnProperty('eventType');
          if (analyticsMetaProvided) {
            var _document = document,
              activeElement = _document.activeElement,
              body = _document.body;
            window._analytics.nuiDispatchEvent.apply(window._analytics.nuiDispatchEvent, [document, 'virtual.event', {
              ea: action.type
            }, _objectSpread({
              activeElement: activeElement === body ? window._analytics.lastActiveTarget : activeElement,
              type: action.type,
              logEntry: logEntry
            }, analyticsMeta), nextState]);
            if (window._analytics.lastActiveTarget) {
              window._analytics.lastActiveTarget = null;
            }
          }
        }
        return returnedValue;
      };
    };
  };
}
var analyticsMiddleware = createAnalyticsMiddleware();
analyticsMiddleware.withOptions = createAnalyticsMiddleware;
var _default = exports.default = analyticsMiddleware;